"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminLoginBodyToJSON = exports.AdminLoginBodyFromJSONTyped = exports.AdminLoginBodyFromJSON = void 0;
function AdminLoginBodyFromJSON(json) {
    return AdminLoginBodyFromJSONTyped(json, false);
}
exports.AdminLoginBodyFromJSON = AdminLoginBodyFromJSON;
function AdminLoginBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'username': json['username'],
        'password': json['password'],
    };
}
exports.AdminLoginBodyFromJSONTyped = AdminLoginBodyFromJSONTyped;
function AdminLoginBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'username': value.username,
        'password': value.password,
    };
}
exports.AdminLoginBodyToJSON = AdminLoginBodyToJSON;
